export const GRANDROUND_LIST = 'GRANDROUND_LIST';
export const GRANDROUND_DETAILS = 'GRANDROUND_DETAILS';
export const GRANDROUND_MEDWIKI = 'GRANDROUND_MEDWIKI';
export const GRANDROUND_SESSION = 'GRANDROUND_SESSION';
export const GRANDROUND_SPQ = 'GRANDROUND_SPQ';
export const GRANDROUND_VIDEOS = 'GRANDROUND_VIDEOS';
